import * as Font from 'expo-font'
import { FontSource } from 'expo-font'

import Fonts from '../../assets/fonts'

export const loadFonts = (fonts?: Record<string, FontSource>) => {
  return Font.loadAsync({ ...Fonts, ...fonts })
}
